import LanguageSelector from '@ui/LanguageSelector/component'

export default () => {
  const el = document.querySelector<HTMLDetailsElement>('.o-language-selector')
  el && LanguageSelector(el)
}
